<template>
<div class="body-zone" >
  <div class="header-fixed herdershadow">
   <div class="header-zone" >
      <b-navbar toggleable="md" type="dark" variant="info">
      <b-navbar-brand @click="gohome()">
        <img class="web_logo" src="../../assets/images/logo.png" alt="">
        <img class="h5_logo" src="../../assets/images/logo_h5.svg" alt="">
      </b-navbar-brand>
      <i class="min_cn" @click="switchLang('en')" v-show="this.lang=='中文'">EN</i>
      <i class="min_en" @click="switchLang('zh_cn')" v-show="this.lang=='English'">中文</i>
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <b-nav>
            <b-nav-item href="/">{{$t('Nav.Home')}}</b-nav-item>
            <b-nav-item  href="/service">{{$t('Nav.TeSe')}}</b-nav-item>
            <li class="nav-item hangye">
              <p>{{$t('Nav.FangAn')}}</p>
              <div class="hangye_xuanze_zone">
                 <div class="hangye_xuanze">
                  <b-nav-item class="link top_active" @click="refresh" href="/asset">{{$t('Nav.FangAn1')}}</b-nav-item>
                  <b-nav-item class="link" href="/Finance">{{$t('Nav.FangAn2')}}</b-nav-item>
                  <b-nav-item class="link" href="/digital">{{$t('Nav.FangAn3')}}</b-nav-item>
                  <b-nav-item class="link"  href="/origin">{{$t('Nav.FangAn4')}}</b-nav-item>
                </div>
              </div>
            </li>
            <b-nav-item  href="/about">{{$t('Nav.About')}}</b-nav-item>
          </b-nav>
        </b-navbar-nav>
        <!-- <div class="lang">
          <span @click="switchLang('zh_cn')">中文</span>
          <i class="lang_line"></i>
          <span @click="switchLang('en')">EN</span>
        </div> -->
      </b-collapse>
    </b-navbar>
    </div>
  </div>
    <div class="asset_banner1">
      <b-container class="asset_banner1_zone">
        <h2>{{$t('Assset.BannerFt1')}}</h2>
        <h4>{{$t('Assset.BannerFt2')}}</h4>
        <h4>{{$t('Assset.BannerFt3')}}</h4>
      </b-container>
    </div>
    <b-container class="banner-chantong">
      <h4>{{$t('Assset.BannerFt4')}}</h4>
      <p>{{$t('Assset.BannerFt5')}}</p>
      <p>{{$t('Assset.BannerFt6')}}</p>
      <p>{{$t('Assset.BannerFt7')}}</p>
    </b-container>
     <b-container class="banner-asset_fangan">
      <h4>{{$t('Assset.BannerFt8')}}</h4>
      <p>{{$t('Assset.BannerFt9')}}</p>
      <p style="margin-bottom:30px;">{{$t('Assset.BannerFt10')}}</p>
      <div class="asset_img">
         <img  src="../../assets/images/asset.png" alt="">
         <p class="assetft1">{{$t('Assset.BannerFt11')}}</p>
         <p class="assetft2">{{$t('Assset.BannerFt12')}}</p>
         <p class="assetft3">{{$t('Assset.BannerFt13')}}</p>
         <p class="assetft4">{{$t('Assset.BannerFt14')}}</p>
         <p class="assetft5">{{$t('Assset.BannerFt15')}}</p>
         <p class="assetft6">{{$t('Assset.BannerFt16')}}</p>
         <p class="assetft7">{{$t('Assset.BannerFt17')}}</p>
         <p class="assetft8">{{$t('Assset.BannerFt18')}}</p>
         <p class="assetft9">{{$t('Assset.BannerFt19')}}</p>
         <p class="assetft10">{{$t('Assset.BannerFt20')}}</p>
         <p class="assetft11">{{$t('Assset.BannerFt21')}}</p>
         <p class="assetft12">{{$t('Assset.BannerFt22')}}</p>
         <p class="assetft13">{{$t('Assset.BannerFt23')}}</p>
         <p class="assetft14">{{$t('Assset.BannerFt24')}}</p>
         <p class="assetft15">{{$t('Assset.BannerFt25')}}</p>
         <p class="assetft16">{{$t('Assset.BannerFt26')}}</p>
         <p class="assetft17">{{$t('Assset.BannerFt27')}}</p>
         <p class="assetft18">{{$t('Assset.BannerFt28')}}</p>
         <p class="assetft19">{{$t('Assset.BannerFt29')}}</p>
         <p class="assetft20">{{$t('Assset.BannerFt30')}}</p>
      </div>
      <div class="asset_img-h5" >
          <img  src="../../assets/images/asset_H5.png" alt="">
      </div>
      <P class="assetft21">{{$t('Assset.BannerFt31')}}</P>
    </b-container>
    <b-container class="asset_banner2">
      <h4>{{$t('Assset.BannerFt32')}}</h4>
       <b-row>
          <b-col>
            <div class="asset_banner2_zone">
              <img  src="../../assets/images/group_1.png" alt="">
              <div class="asset_banner2_ft_zone">
                <h4>{{$t('Assset.BannerFt33')}}</h4>
                <p>{{$t('Assset.BannerFt34')}}</p>
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="asset_banner2_zone2">
              <img  src="../../assets/images/group_2.png" alt="">
              <div class="asset_banner2_ft_zone">
                <h4>{{$t('Assset.BannerFt35')}}</h4>
                <p>{{$t('Assset.BannerFt36')}}</p>
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="asset_banner2_zone3">
              <img  src="../../assets/images/group_3.png" alt="">
              <div class="asset_banner2_ft_zone">
                <h4>{{$t('Assset.BannerFt37')}}</h4>
                <p>{{$t('Assset.BannerFt38')}}</p>
              </div>
            </div>
          </b-col>
       </b-row>
    </b-container>
    <Bottom></Bottom>
    <div v-bind:class="{goTopShow: isActive }" @click="toTop(step)" class="go-top-zone">
      <i></i>
    </div>
</div>

</template> 

<script>
import storage from '../../models/storage';
import Bottom from "@/pages/assembly/Bottom"
export default {
  name: "RedDetail",
  components: {Bottom},
  props:{
            step:{   //此数据是控制动画快慢的
                type:Number,
                default:120  
            }
        },
  data() {
    return {
      lang:'中文',
      openLang:false,
      isActive:false
    };
  },
   mounted() {
     window.addEventListener('scroll', this.handleScroll)
    let lang=storage.get('lang')
     if(lang=='en'){
        this.lang = 'English'
        this.langnum=1
      }
      if(lang=='zh_cn'){
        this.lang = '中文'
        this.langnum=0
      }
   },
   created(){
     this.menu()
   },
  methods: {
     menu() {
      window.scrollTo(0,0);
      },
    toTop(i){
                //参数i表示间隔的幅度大小，以此来控制速度
                document.documentElement.scrollTop-=i;
                if (document.documentElement.scrollTop>0) {
                    var c=setTimeout(()=>this.toTop(i),16);
                }else {
                    clearTimeout(c);
                }
            },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if(scrollTop!=0){
        this.isActive = true
      }
      else{
        this.isActive = false
      }
    },
    refresh(){
      this.$router.push({path: "/asset"});
      window.scrollTo(0,0);
      window.location.reload()
    },
    gohome(){
      this.$router.push({path: "/"});
      window.scrollTo(0,0);
      window.location.reload()
    },
    enter(){
      this.openLang=true
    },
    leave(){
      this.openLang=false
    },
    switchLang(lang)  {
      if(lang=='en'){
        this.lang = 'English'
      }
      if(lang=='zh_cn'){
        this.lang = '中文'
      }
        this.$i18n.locale = lang
        storage.set('lang',lang);
    },
    get_history: function (uuid) {
          luckmoney.getHistory(uuid).then(result => {
          }).catch(e => {
            console.log(e)
          })
        },
  }
};
</script>
<style  lang="scss"  scoped>
  @import "../../assets/css/Index.scss";  
</style>


// WEBPACK FOOTER //
// src/pages/asset/Asset.vue